import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { cn } from "@/lib/utils";
import { OptionsContext } from "@/provider/options-provider";
import { useContext } from "react";
import { UseFormReturn } from "react-hook-form";
import { Input } from "./ui/input";

const Question = ({ form }: { form: UseFormReturn<any> }) => {
  const { searchOptions, setSearchOptions } = useContext(OptionsContext);
  return (
    <FormField
      control={form.control}
      name="question"
      render={({ field }) => (
        <FormItem className={cn("flex h-full w-full")}>
          <FormControl>
            <Input
              {...field}
              className={cn(
                "focus:ring-3 search-field flex h-full w-full border-0 bg-slate-100 py-0 pl-3 pr-3 text-gray-900 ring-1 placeholder:text-gray-400 sm:text-sm",
              )}
              placeholder={"Question..."}
              type="search"
              name="search"
              autoComplete="off"
              value={searchOptions.question}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, question: e.target.value })
              }
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default Question;
